import { MasterDetailListEntry } from "@sdbn/common";

export enum StationType {
  WORKING_AREA = 'WORKING_AREA',
  WAITING_AREA = 'WAITING_AREA'
}

export enum RetrievalStrategy {
  FIFO = 'FIFO', LIFO = 'LIFO'
}


export class TransportCreationProfile {

  id: number;
  name: string;

  constructor(profile?: TransportCreationProfile) {
    if (profile != null) {
      this.id = profile.id;
      this.name = profile.name;
    }
  }
}

export class TransportCreationProfileToStation {

  id: number;
  index: number;
  transportCreationProfileId: number;
  displayName: string;
  deleted: boolean;

  constructor(profile?: TransportCreationProfileToStation) {
    if (profile != null) {
      this.id = profile.id;
      this.displayName = profile.displayName;
      this.index = profile.index;
      this.transportCreationProfileId = profile.transportCreationProfileId;
      this.deleted = profile.deleted;
    }
  }
}

export class Station implements MasterDetailListEntry {

  id: number;
  name: string;
  nameForMessaging: string;
  description: string;
  stationType: StationType;
  identifier: string;
  internal: string;
  capacity: number;
  disabled: boolean;
  externalKey: string;
  referenceDuration: number;
  suggestNextTransport: boolean;
  plannedTransportAssignmentPossible: boolean;
  bufferZoneId: number;
  transportCreationProfiles = new Array<TransportCreationProfileToStation>();
  deletedTransportCreationProfiles = new Array<TransportCreationProfileToStation>();
  opened: boolean;
  retrievalStrategy: RetrievalStrategy;
  navigationLink: string;
  useForManualStationSelection: boolean;

  constructor(station?: any) {
    if (station != null) {
      this.id = station.id;
      this.name = station.name;
      this.nameForMessaging = station.nameForMessaging;
      this.description = station.description;
      this.stationType = station.stationType;
      this.identifier = station.identifier;
      this.internal = station.internal;
      this.capacity = station.capacity;
      this.disabled = station.disabled;
      this.externalKey = station.externalKey;
      this.referenceDuration = station.referenceDuration;
      this.suggestNextTransport = station.suggestNextTransport;
      this.plannedTransportAssignmentPossible = station.plannedTransportAssignmentPossible;
      this.bufferZoneId = station.bufferZoneId;
      this.opened = station.opened === true;
      this.retrievalStrategy = station.retrievalStrategy;
      this.navigationLink = station.navigationLink;
      this.useForManualStationSelection = station.useForManualStationSelection;
      if (station.transportCreationProfiles != null) {
        for (const p of station.transportCreationProfiles) {
          this.transportCreationProfiles.push(new TransportCreationProfileToStation(p));
        }
      }
    }
  }

  isWaitingArea(): boolean {
    return this.stationType === StationType.WAITING_AREA;
  }

  public get listTitle(): string {
    return this.name;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return this.identifier;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return null;
  }
}
